package com.iregained.site.components.sections.product.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

val AudienceCardStyle = CssStyle {
    base {
        val palette = colorMode.toSitePalette()
        Modifier
            .borderRadius(16.px)
            .overflow(com.varabyte.kobweb.compose.css.Overflow.Hidden)
            .boxShadow(0.px, 10.px, 25.px, color = palette.custom.darkText.toRgb().copyf(alpha = 0.05f))
            .transition(
                Transition.of("transform", 0.4.s),
                Transition.of("box-shadow", 0.4.s)
            )
    }
    hover {
        val palette = colorMode.toSitePalette()
        Modifier
            .translateY((-8).px)
            .boxShadow(0.px, 20.px, 40.px, color = palette.custom.darkText.toRgb().copyf(alpha = 0.15f))
    }
}